(() => {
  async function load(root) {
    if (root.dataset.loading) return;
    root.dataset.loading = 'true';
    const layout = root.querySelector('[data-related-layout]').content.cloneNode(true);
    const grid = layout.querySelector('[data-related-grid]');
    const fabrics = new Set();
    const products = new Set();
    const visited = new Set();
    let batch = root.querySelector('[data-related-cards]');
    try {
      while (batch && root.isConnected) {
        for (const card of batch.content.querySelectorAll('.slider__item')) {
          if (grid.children.length === 6) break;
          if (fabrics.has(card.dataset.fabricId) || products.has(card.dataset.productId)) continue;
          fabrics.add(card.dataset.fabricId);
          products.add(card.dataset.productId);
          grid.appendChild(card.cloneNode(true));
        }
        if (grid.children.length === 6 || !batch.dataset.nextUrl) break;
        const url = new URL(batch.dataset.nextUrl, window.location.href);
        url.searchParams.set('section_id', root.dataset.sectionId);
        if (url.origin !== window.location.origin || visited.has(url.href)) break;
        visited.add(url.href);
        const response = await fetch(url.href, { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Related fabrics request failed');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        batch = doc.querySelector('[data-related-cards]');
      }
    } catch (error) {
      // Keep any verified matches already found; never substitute unrelated cards.
      console.warn('Related fabrics could not finish loading.', error);
    }
    if (!root.isConnected || !grid.children.length) return;
    // Mount only after gathering cards: CarouselSlider reads slides in its constructor.
    root.hidden = false;
    root.replaceChildren(layout);
  }
  function init(scope) {
    scope.querySelectorAll('[data-related-fabrics]').forEach(load);
  }
  init(document);
  if (!window.ptRelatedFabricsEditorListener) {
    window.ptRelatedFabricsEditorListener = true;
    document.addEventListener('shopify:section:load', (event) => init(event.target));
  }
})();
